// 
import WebComponent from '../src/webComponents/WebComponent';
import 'bootstrap-slider';
import $ from 'jquery';
import {formatCurrency} from '../plugins/utils';

class Slider extends WebComponent {
  constructor(props) {
    super(props);
    this.ticks = {};
    this.formatter = this.formatter.bind(this);
  }

  didMount() {
    let {
      sliderMin,
      sliderMax,
      sliderStep,
      ticksTitles,
    } = this.props;

    let sliderTicks = [];
    let sliderScale = 'linear';
    let sliderPrecision = 0;

    const typeSliderMin = Number.isInteger(parseFloat(sliderMin));
    const typeSliderMax = Number.isInteger(parseFloat(sliderMax));
    const typeSliderStep = Number.isInteger(parseFloat(sliderStep));

    if (ticksTitles) {
      this.ticks = ticksTitles;

      let keyValue;
      let decimalLength;

      for (var key in ticksTitles) {
        if (ticksTitles.hasOwnProperty(key)) {
          keyValue = parseFloat(key);

          if (!Number.isInteger(keyValue)) {
            decimalLength = keyValue.toString().split('.')[1].length;
            if (decimalLength > sliderPrecision) {
              sliderPrecision = decimalLength;
            }
          }

          sliderTicks.push(keyValue);
        }
      }

      if (sliderPrecision > 0) {
        let sliderStepString = '1';

        for (let i = 0; i < sliderPrecision; i++) {
          sliderStepString += '0';
        }

        sliderStep = 1 / parseFloat(sliderStepString);
      }
    }
    else {
      if ((!typeSliderMin || !typeSliderMax) && (typeSliderStep)) {
        sliderStep = parseFloat(`${sliderStep}.1`);
      }
    }

    $(this.element).bootstrapSlider({
      tooltip: 'always',
      tooltip_split: true,
      formatter: this.formatter,
      step: sliderStep,
      ticks: sliderTicks,
      lock_to_ticks: true,
      scale: sliderScale,
      precision: sliderPrecision,
    });
  }

  formatter(val) {
    const {
      unit,
      ticksTitles,
    } = this.props;

    let result;

    if (Array.isArray(val)) {
      return `${val[0]} -  ${val[1]} ${unit || ''}`;
    } else {
      if (typeof unit !== 'undefined') {
        return `${formatCurrency(val)} ${unit || ''}`;
      } else if (typeof ticksTitles !== 'undefined') {
        if (val in this.ticks) {
          result = this.ticks[val].replace(/(<([^>]+)>)/ig,'');

          if (result.split(' ').length == 2) {
            return result;
          }
          else {
           return `${formatCurrency(result)}`;
          }
        }
      }
    }
    return `${formatCurrency(val)}`;
  }
}

Slider.defaultProps = {
  sliderStep: 1,
}

export default Slider;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/Slider.js